/**
 * Created by Fedor on 09.10.2026
 */

class BgCoverComponent extends BaseComponent {
    onCreate() {
        this.scale = PrefabBuilder.resolveProperty(this.options.scale, this.context) || 1;
    }

    onAttach() {
        this.onResize();
    }

    onResize() {
        const bgRect = cleverapps.resolution.getBgRect();

        const scale = this.scale * Math.max(bgRect.width / this.node.width, bgRect.height / this.node.height);
        this.node.setScale(Math.max(scale, 1));
    }
}

Prefab.registerComponent("BgCoverComponent", BgCoverComponent);
